import jwt_decode from "jwt-decode";
import {UserController} from "@/controllers/user/UserController";
import {NotificationService} from "@vues/v-common";

/**
 * Permet de gérer tout ce qui est lié à l'utilisateur
 */
export class TokenService {

    jwtTokenSecret = "Hm44FfGP5GMVfYqW7kCrzP7VS8HGLNXNj5by3qbAmLU1r412Ryj4m7EeXYdhLPy";

    /**
     * Setup for make this class a Singleton
     */
    constructor() {
        if (TokenService.exists) {
            return TokenService.instance;
        }
        TokenService.instance = this;
        TokenService.exists = true;
        return this;
    }

    setJwtTokenSecret(jwtTokenSecret) {
        this.jwtTokenSecret = jwtTokenSecret;
    }

    static verifyJWT(token) {
        if (token === null || token === undefined) throw 'Token is null';
        return jwt_decode(token, this.jwtTokenSecret);
    }

    static setToken(token_str, encryptionKey) {
        // Clear local storage before to avoid an eventual previous localstorage collision
        localStorage.clear();
        localStorage.token = token_str;

        const token = this.verifyJWT(localStorage.token);
        Object.assign(localStorage, token);

        localStorage.isConnected = true;
        localStorage.encryptionKey = encryptionKey;
        localStorage.isInvoiceTransmissionLinked = false;
        if(token.isNeedToChangeGroup) {
            localStorage.isNeedToChangeGroup = true;
        }

        return  token;
    }

    static async renewToken() {
        const res = await UserController.renewToken();
        if (!res.errors) {
            this.setToken(res.token, localStorage.encryptionKey);
        }else{
            (new NotificationService).addNotification("warning","Veuillez vous reconnecter");
        }

    }

}
